import React from 'react';
import type { KeyboardEventHandler, Ref } from 'react';
import type { AnyMessage } from '../chatTypes';
import { isTextMessage } from '../chatTypes';
import ChatTextMessage from './ChatTextMessage';

export type ChatMessageComponentProps = {
  message: AnyMessage;
  tabIndex?: number;
  messageRef?: Ref<HTMLDivElement>;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  onFocus?: React.FocusEventHandler<HTMLDivElement>;
};

export default function ChatMessageComponent({
  message,
  tabIndex,
  messageRef,
  onKeyDown,
  onFocus
}: Readonly<ChatMessageComponentProps>): React.JSX.Element {
  //TODO: add implementation for other message types
  if (isTextMessage(message)) {
    return (
      <ChatTextMessage
        person={message.user}
        date={message.date}
        text={message.content.text}
        errorText={message.error}
        status={message.status}
        tabIndex={tabIndex}
        messageRef={messageRef}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
      />
    );
  }

  // should never happen
  return <>Unknown message type</>;
}
